import { Colors } from '@/common/colors/colors';
import Icon from '@/common/components/Icon';

export const getRows = (
	files,
	loadingFiles,
	setShow,
	setSelectedFile,
	handleDownloadFile,
) => {
	return files
		.sort((a, b) => a.filename.localeCompare(b.filename))
		.map((file, index) => {
			return (
				<tr key={`${file._id}`}>
					<td>{index + 1}</td>
					<td>{`${file.info ?? ''} ${file.filename}`.trim()}</td>
					<td>{file.language?.label ?? '---'}</td>
					<td>{file.extension}</td>
					<td>{file.mimetype}</td>
					<td
						style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}
					>
						<Icon
							onClick={() => {
								setShow(true);
								setSelectedFile(file);
							}}
							name='fa fa-edit'
						/>
						{loadingFiles.includes(file._id) ? (
							<Icon onClick={() => false} name='fa fa-spinner fa-spin' />
						) : (
							<Icon
								color={Colors.green}
								onClick={() => handleDownloadFile(file)}
								name='fa fa-download'
							/>
						)}
					</td>
				</tr>
			);
		});
};
